import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Text } from 'recharts';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { max, random } from 'lodash';
import { Card, CardActionArea, CardMedia } from '@material-ui/core';
import CancelButton from '../../components/atoms/CancelButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import FileUploadIdentity from '../../components/molecules/FileUploadIdentity';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { uploadFile, sendLogin } from '../../auth/Auth';
import { getIdentities, editIdentity } from '../../actions/Identity';
import { getShops } from '../../actions/Shop';
import AddMoreButton from '../../components/atoms/AddMoreButton';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  modalTitileDiv: {
    marginBottom: '4%'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    }
  },
  inputLabel: {
    display: 'inline'
  },
  input: {
    display: 'none'
  },
  textField: {
    padding: '0px 5px 0px 5px'
  },
  bold: {
    fontWeight: 'bold'
  },
  colorBlack: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  underline: {
    textDecoration: 'underline'
  },
  indent_2: {
    marginLeft: '15px',
    display: 'block'
  },
  indent_4: {
    marginLeft: '30px',
    display: 'block'
  },
  mb10: {
    marginBottom: 10
  },
  image: {
    width: '300px',
    margin: '5px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '5px 0'
    }
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getIdentities,
          editIdentity,
          getShops
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openRegisterProgress', 'updateOpenRegisterProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isRegisterSuccess', 'updateIsRegisterSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('sealCertificate', 'setSealCertificate', []),
  withState('businessLicense', 'setBusinessLicense', []),
  withState('registerCopy', 'setRegisterCopy', []),
  withState('note', 'setNote', ''),
  withState('numberIdentity', 'setNumberIdentity', ''),
  withState('previewImageSeal', 'setPreviewImageSeal', []),
  withState('previewImageLicense', 'setPreviewImageLicense', []),
  withState('previewImageRegisterCopy', 'setPreviewImageRegisterCopy', []),
  withState('agreeOne', 'setAgreeOne', false),
  withState('agreeTwo', 'setAgreeTwo', false),
  withState('agreeThree', 'setAgreeThree', false),
  withState('numberSealCertificate', 'setNumberSealCertificate', 1),
  withState('numberBusinessLicense', 'setNumberBusinessLicense', 1),
  withState('numberRegisterCopy', 'setNumberRegisterCopy', 1),
  withState('businessLicenseType', 'setBusinessLicenseType', []),
  withState('sealCertificateType', 'setSealCertificateType', []),
  withState('registerCopyType', 'setRegisterCopyType', []),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey = null,
    openRegisterProgress,
    updateOpenRegisterProgress,
    loading,
    updateLoading,
    isRegisterSuccess,
    updateIsRegisterSuccess,
    resultMessage,
    setResultMessage,
    sealCertificate,
    setSealCertificate,
    businessLicense,
    setBusinessLicense,
    registerCopy,
    setRegisterCopy,
    note,
    setNote,
    previewImageSeal,
    setPreviewImageSeal,
    previewImageLicense,
    setPreviewImageLicense,
    previewImageRegisterCopy,
    setPreviewImageRegisterCopy,
    updateOpenRegisterModal,
    targetRowId,
    agreeOne,
    setAgreeOne,
    agreeTwo,
    setAgreeTwo,
    agreeThree,
    setAgreeThree,
    bankAccountHolder,
    setBankAccountHolder,
    numberIdentity,
    setNumberIdentity,
    shopSearchKey,
    numberSealCertificate,
    setNumberSealCertificate,
    numberBusinessLicense,
    setNumberBusinessLicense,
    numberRegisterCopy,
    businessLicenseType,
    setBusinessLicenseType,
    sealCertificateType,
    setSealCertificateType,
    registerCopyType,
    setRegisterCopyType,
    registeredCopyImage
  }) => {
    const cancelAction = () => updateOpenRegisterModal(false);
    const registAction = async () => {
      if (
        (sealCertificate.length > 0 &&
          businessLicense.length > 0 &&
          (registerCopy.length > 0 ||
            (registeredCopyImage && registeredCopyImage.length > 0))) ||
        note !== ''
      ) {
        updateLoading(true);
        updateOpenRegisterProgress(true);
        let sealPath = [];
        let licensePath = [];
        let registerCopyPath = [];
        if (sealCertificate.length > 0) {
          const imagePaths = await Promise.all(
            sealCertificate.map(async image => {
              if (image) {
                const imagePath = await uploadFile(
                  'identity',
                  targetRowId,
                  image,
                  'public'
                );
                return imagePath;
              }
              return null;
            })
          );
          sealPath = imagePaths
            .filter(i => i !== null)
            .map((i, index) => {
              return { image: i, viewOrder: index };
            });
        }
        if (businessLicense.length > 0) {
          const imagePaths = await Promise.all(
            businessLicense.map(async image => {
              if (image) {
                const imagePath = await uploadFile(
                  'identity',
                  targetRowId,
                  image,
                  'public'
                );
                return imagePath;
              }
              return null;
            })
          );
          licensePath = imagePaths
            .filter(i => i !== null)
            .map((i, index) => {
              return { image: i, viewOrder: index };
            });
        }
        if (registerCopy.length > 0) {
          const imagePaths = await Promise.all(
            registerCopy.map(async image => {
              if (image !== null) {
                const imagePath = await uploadFile(
                  'identity',
                  targetRowId,
                  image,
                  'public'
                );
                return imagePath;
              }
              return null;
            })
          );
          registerCopyPath = imagePaths
            .filter(i => i !== null)
            .map((i, index) => {
              return { image: i, viewOrder: index };
            });
        } else if (
          registerCopy.length === 0 &&
          registeredCopyImage &&
          registeredCopyImage.length > 0
        ) {
          const imagePaths = registeredCopyImage;
          registerCopyPath = imagePaths
            .filter(i => i !== null)
            .map((i, index) => {
              return { image: i, viewOrder: index };
            });
        }

        const identityImages = [];
        const maxLengthImage = max([
          sealCertificate.length,
          businessLicense.length,
          registerCopy.length
        ]);
        if (maxLengthImage) {
          for (let i = 0; i < maxLengthImage; i += 1) {
            identityImages.push({
              sealCertificate: sealPath[i] ? sealPath[i].image : '',
              registeredCopy: registerCopyPath[i]
                ? registerCopyPath[i].image
                : '',
              other: licensePath[i] ? licensePath[i].image : ''
            });
          }
        }

        const editedIdentity = await actions
          .editIdentity(targetRowId, {
            sealCertificate:
              sealPath.length > 0 && sealPath[0].image
                ? sealPath[0].image
                : null,
            businessLicense:
              licensePath.length > 0 && licensePath[0].image
                ? licensePath[0].image
                : null,
            registeredCopy:
              (registerCopyPath.length > 0 && registerCopyPath[0].image) ||
              null,
            note,
            bankAccountHolder,
            numberIdentity,
            identityImages
          })
          .then(data => checkSession(data));
        if (editedIdentity.type === 'EDIT_IDENTITY_SUCCESS') {
          updateIsRegisterSuccess(true);
          if (searchKey) {
            // 本人確認書類検索からの登録の場合
            await actions
              .getIdentities(searchKey)
              .then(data => checkSession(data));
          } else {
            // グループ情報管理からの登録の場合
            await actions
              .getShops(shopSearchKey || undefined)
              .then(data => checkSession(data));
          }
          setResultMessage('登録が完了しました。');
          updateLoading(false);
        } else {
          updateIsRegisterSuccess(false);
          setResultMessage('登録に失敗しました。');
          updateLoading(false);
        }
      } else {
        alert('本人確認資料を登録してください。');
      }
    };

    const progressOkAction = () => {
      if (isRegisterSuccess) {
        updateOpenRegisterModal(false);
        updateOpenRegisterProgress(false);
      } else {
        updateOpenRegisterProgress(false);
      }
    };

    const handleSetBusinessLicense = (value, index) => {
      const tmpValue = [...businessLicense];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setBusinessLicense([...tmpValue]);
    };

    const handleSetPreviewImageLicense = (value, index) => {
      const tmpValue = [...previewImageLicense];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setPreviewImageLicense([...tmpValue]);
    };

    const handleSetBusinessLicenseType = (value, index) => {
      const tmpValue = [...businessLicenseType];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setBusinessLicenseType([...tmpValue]);
    };

    const getBusinessLicenseButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberBusinessLicense; i += 1) {
        arrButton.push(
          <FileUploadIdentity
            key={random(true)}
            label={`license-${i}`}
            setFile={handleSetBusinessLicense}
            previewImage={previewImageLicense[i]}
            setPreviewImage={handleSetPreviewImageLicense}
            indexNumber={i}
            setType={handleSetBusinessLicenseType}
            type={businessLicenseType[i]}
            largePreview
          />
        );
      }
      return arrButton;
    };

    const handleSetSealCertificate = (value, index) => {
      const tmpValue = [...sealCertificate];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setSealCertificate([...tmpValue]);
    };

    const handleSetSealCertificateType = (value, index) => {
      const tmpValue = [...sealCertificateType];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setSealCertificateType([...tmpValue]);
    };

    const handleSetPreviewImageSeal = (value, index) => {
      const tmpValue = [...previewImageSeal];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setPreviewImageSeal([...tmpValue]);
    };

    const getSealCertificateButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberSealCertificate; i += 1) {
        arrButton.push(
          <FileUploadIdentity
            key={random(true)}
            label={`seal-${i}`}
            setFile={handleSetSealCertificate}
            previewImage={previewImageSeal[i]}
            setPreviewImage={handleSetPreviewImageSeal}
            indexNumber={i}
            setType={handleSetSealCertificateType}
            type={sealCertificateType[i]}
            largePreview
          />
        );
      }
      return arrButton;
    };

    const handleSetRegisterCopy = (value, index) => {
      const tmpValue = [...registerCopy];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setRegisterCopy([...tmpValue]);
    };

    const handleSetRegisterCopyType = (value, index) => {
      const tmpValue = [...registerCopyType];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setRegisterCopyType([...tmpValue]);
    };

    const handleSetPreviewImageRegisterCopy = (value, index) => {
      const tmpValue = [...previewImageRegisterCopy];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setPreviewImageRegisterCopy([...tmpValue]);
    };

    const getRegisterCopyButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberRegisterCopy; i += 1) {
        arrButton.push(
          <FileUploadIdentity
            key={random(true)}
            label={`registerCopy-${i}`}
            setFile={handleSetRegisterCopy}
            previewImage={previewImageRegisterCopy[i]}
            setPreviewImage={handleSetPreviewImageRegisterCopy}
            indexNumber={i}
            setType={handleSetRegisterCopyType}
            type={registerCopyType[i]}
            largePreview
          />
        );
      }
      return arrButton;
    };

    return (
      <div className={classes.root}>
        <div className={classes.modalTitileDiv}>
          <Typography variant="h6">本人確認書類登録</Typography>
          <Typography color="textSecondary">
            本人確認書類として下記の画像をアップロードしてください。
            <br />
            <br />
            個人事業主：
            <Text className={[classes.bold, classes.colorBlack]}>
              「①営業許可証」「②印鑑証明書・身分証明書・公共料金の領収証いずれか」「③振込先銀行通帳の1ページ目」
            </Text>
            <br />
            法人：
            <Text className={[classes.bold, classes.colorBlack]}>
              「①営業許可証」「②法人の印鑑証明書」「③振込先銀行通帳の1ページ目」「④法人番号の入力」
            </Text>
            <br />
            <br />
            <Text className={[classes.bold, classes.colorBlack]}>
              上記の全てが揃っている必要があります。
            </Text>
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div>
            <Typography variant="h6" color="textPrimary">
              証明書添付
            </Typography>
          </div>
          <br />
          <div>
            <Typography variant="p" color="textSecondary">
              <Text className={[classes.bold, classes.colorBlack]}>
                ①【必須】営業許可証
              </Text>
              <br />
              ※風営適正化法による許可・届け出をしている場合はその営業許可証を必ず提出してください。
              <br />
              ※風俗営業の1号営業～4号営業、性風俗関連特殊営業はご登録できかねます。
              <br />
              ※飲食店以外の店舗さまの場合は、登記簿謄本（履歴事項全部証明書）全ページ但し登録店舗の住所の記載があるもの・開業廃業等届書・飲食店の営業許可証に類する「代表者名」「住所」「店舗名」などが確認できる公的な書類、のいずれかを提出してください。
              <br />
              福岡市子ども習い事応援事業の事業者の場合は、「福岡市子ども習い事応援事業参画事業者募集要項」にある
              「事業実態確認書類」を提出してください。
            </Typography>
            {getBusinessLicenseButtons()}
            <AddMoreButton
              disabled={numberBusinessLicense >= 5}
              onClickAction={() =>
                setNumberBusinessLicense(numberBusinessLicense + 1)
              }
            />
          </div>
          <div>
            <Typography variant="p" color="textSecondary">
              <Text className={[classes.bold, classes.colorBlack]}>
                ②【必須】個人事業主の場合は下記のいずれか、法人の場合は1.印鑑証明のみ有効
              </Text>
              <br />
              <Text
                className={[classes.bold, classes.colorBlack, classes.indent_2]}
              >
                1. 印鑑証明（取得から1年以内）
              </Text>
              <Text className={classes.indent_4}>
                ※①の営業許可証に記載の氏名・法人のものに限る
              </Text>
              <Text
                className={[classes.bold, classes.colorBlack, classes.indent_2]}
              >
                2. 公共料金の領収書（発行から一年以内）
              </Text>
              <Text className={classes.indent_4}>
                ※①の営業許可証に記載の氏名・法人名と、住所と同一の記載があるものに限る
              </Text>
              <Text
                className={[classes.bold, classes.colorBlack, classes.indent_2]}
              >
                3. 身分証明書
              </Text>
              <Text className={classes.indent_4}>
                ※①の営業許可証に記載のある氏名の運転免許証・パスポート・健康保険証のいずれかに限る
              </Text>
            </Typography>
            {getSealCertificateButtons()}
            <AddMoreButton
              disabled={numberSealCertificate >= 5}
              onClickAction={() =>
                setNumberSealCertificate(numberSealCertificate + 1)
              }
            />
          </div>

          <div>
            <Typography
              variant="p"
              color="textSecondary"
              className={classes.bold}
            >
              <Text className={[classes.bold, classes.colorBlack]}>
                ③【必須】振込先銀行通帳の1ページ目
              </Text>
              <Text className={classes.indent_4}>
                表紙を開いて振込先の銀行・支店・口座番号・名義人が全て記載されているページ
              </Text>
            </Typography>
            {getRegisterCopyButtons()}
            {registeredCopyImage &&
              registeredCopyImage.length > 0 &&
              registerCopy.length === 0 && (
                <Card className={classes.image}>
                  <CardActionArea>
                    <CardMedia component="img" image={registeredCopyImage[0]} />
                  </CardActionArea>
                </Card>
              )}
          </div>

          <div>
            <div className={classes.mb10}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agreeOne}
                    color="primary"
                    onChange={e => {
                      setAgreeOne(e.target.checked);
                    }}
                  />
                }
                label="ごちめしに登録した情報と一致する本人確認書類を、上記のとおり揃え、登録します。"
              />
            </div>

            <div className={classes.mb10}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agreeTwo}
                    color="primary"
                    onChange={e => {
                      setAgreeTwo(e.target.checked);
                    }}
                  />
                }
                label={
                  <div>
                    風俗営業の1号営業〜4号営業、性風俗関連特殊営業は行っていません。
                    <br />
                    風営適正化法による許可・届出をしている場合は、その営業許可証をアップロードし、登録します。
                  </div>
                }
              />
            </div>

            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agreeThree}
                    color="primary"
                    onChange={e => {
                      setAgreeThree(e.target.checked);
                    }}
                  />
                }
                label="虚偽の申請・営業実態が異なる場合、サービス利用中であっても登録取消になることに同意します。"
              />
            </div>
          </div>
          <div>
            <Typography
              variant="p"
              color="textSecondary"
              className={classes.bold}
            >
              <Text className={[classes.bold, classes.colorBlack]}>
                ④【法人の店舗さま必須】法人番号
              </Text>
            </Typography>
          </div>
          <div>
            <TextField
              rows="1"
              type="number"
              placeholder="0123456789012"
              fullWidth
              className={classes.textField}
              margin="normal"
              value={numberIdentity}
              onChange={e => {
                setNumberIdentity(e.target.value);
              }}
            />
          </div>
        </Paper>
        <Paper className={classes.mainPaper} elevation={1}>
          <div>
            <Typography variant="h6" color="textSecondary">
              【任意】その他連絡事項
            </Typography>
          </div>
          <br />
          <div>
            <TextField
              multiline
              rows="4"
              placeholder="その他、連絡する事項などありましたらご記載ください。"
              fullWidth
              className={classes.textField}
              margin="normal"
              value={note}
              onChange={e => {
                setNote(e.target.value);
              }}
            />
          </div>
        </Paper>
        <div className={classes.itemDiv}>
          <TextField
            label="口座名義"
            value={bankAccountHolder}
            rows="1"
            fullWidth
            className={classes.textFieldLong}
            margin="normal"
            onChange={e => {
              setBankAccountHolder(e.target.value);
            }}
          />
        </div>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <RegisterButton
            onClickAction={registAction}
            disabled={!(agreeOne && agreeTwo && agreeThree)}
          />
        </div>
        <ProgressDialog
          openProgress={openRegisterProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
